import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class IconBackground extends React.Component {
    icons = [
        'thumbs-up',
        'comment-alt',
        'lightbulb',
        'microphone-alt',
        'bullhorn',
        'comments',
        'paper-plane',
    ]

    randomIcon() {
        return this.icons[Math.floor(Math.random() * this.icons.length)]
    }

    randomIconAndStyle(row, col) {
        const rotation =
            Math.round(360 * Math.random()) * (Math.random() < 0.5 ? -1 : 1)

        const offsetX =
            Math.round(55 * Math.random()) *
            (Math.random() < 0.5 ? -1 : 1) *
            0.75

        const offsetY =
            Math.round(20 * Math.random()) *
            (Math.random() < 0.5 ? -1 : 1) *
            0.75

        const opacity =
            Math.min(Math.round(12 * Math.random() + 2), 15 - row) * 0.65

        const style = {
            transform: `rotate(${rotation}deg) translate(${offsetX}px, ${offsetY}px)`,
            opacity: `${opacity}%`,
            // fillOpacity: `${opacity}%`,
        }

        return <FontAwesomeIcon style={style} icon={this.randomIcon()} />
    }

    isBrowserCompatible = () => {
        navigator.sayswho= (function(){
            var ua= navigator.userAgent, tem, 
            M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if(/trident/i.test(M[1])){
                tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE '+(tem[1] || '');
            }
            if(M[1]=== 'Chrome'){
                tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
                if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
            if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
            return M.join(' ');
        })();

        const version = navigator.sayswho
        if (version.toLowerCase().includes("chrome")) return true
        
        if (version.toLowerCase().includes("firefox")) {
            return false
        } 
        
        return false
    }

    render() {
        if (!this.isBrowserCompatible()) return <></>

        const numRows = 12
        const numCols = 12

        const renderIconGrid = () => {
            var rows = []

            for (var r = 0; r < numRows; r++) {
                var columns = []

                for (var c = 0; c < numCols; c++) {
                    columns.push(
                        <div key={c} className="col">
                            {this.randomIconAndStyle(r, c)}
                        </div>
                    )
                }

                rows.push(
                    <div key={r} className="row mt-3">
                        {columns}
                    </div>
                )
            }
            return rows
        }

        return <div className="icon-background">{renderIconGrid()}</div>
    }
}
